<template>
  <Teleport to="body">
    <transition name="fade">
      <div
        v-if="isAlertShown"
        :class="[
          alertClass,
          '!wd-z-alert wd-text-white wd-rounded wd-flex wd-align-center wd-text-base wd-px-5 wd-py-4 wd-fixed wd-z-50 wd-left-4 wd-right-4 wd-bottom-19 md:wd-top-6 md:wd-right-24 md:wd-bottom-auto md:wd-left-auto md:wd-w-100',
        ]"
      >
        <span> {{ checkedText }} </span>

        <v-spacer />

        <v-btn class="close-btn" :min-width="24" :width="24" :height="24" variant="text" @click="hideAlert">
          <v-icon :size="20" color="white"> mdi-close </v-icon>
        </v-btn>
      </div>
    </transition>
  </Teleport>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { Teleport } from 'vue'
import { useAlertStore } from '@/store-pinia/alert'
import type { AlertType } from '@/view-models/common'

const i18n = useI18n()
const alertStore = useAlertStore()
const { isAlertShown, alertType, alertText } = storeToRefs(alertStore)
const checkedText = computed(() => (i18n.te(alertText.value) ? i18n.t(alertText.value) : alertText.value))
const { hideAlert } = alertStore

const alertClassMap: Record<AlertType, string> = {
  error: 'wd-bg-red50',
  success: 'wd-bg-green70',
  info: 'wd-bg-orange50',
}
const alertClass = computed(() => alertClassMap[alertType.value])

watch(isAlertShown, isShown => {
  if (isShown) {
    return
  }
  alertStore.clearAlert()
})
</script>

<style lang="scss" scoped>
@use '@/assets/sass/modules/_animations.scss' as *;
</style>
